import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

const useAccessToken = (scopes) => {
    if (!scopes) {
        throw new Error('useAccessToken - scopes parameter not provided');
    }

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts, inProgress } = useMsal();
    const [accessToken, setAccessToken] = React.useState(null);

    React.useEffect(() => {
        if (isAuthenticated && inProgress === InteractionStatus.None) {
            instance.acquireTokenSilent({
                account: accounts[0],
                scopes
            }).then((response) => {
                setAccessToken(response.accessToken);
            });
        }
    }, [inProgress, isAuthenticated, accounts, instance, scopes]);

    return accessToken;
};

export default useAccessToken;